module.exports = __webpack_public_path__ + "assets/images/project/lower-pierce-reservoir/02.jpg?v=faf34ce5";